import type { ReactNode } from 'react';
import {
  filterUniqueProducts,
  parseProducts,
} from '../IngredientsAndEquipment/helpers/parseIngredients';
import { Link } from 'components/Link';
import NextImage from '../NextImage';
import { ImagesService } from 'service/images/imagesService';
import { StyledTitle, ProductWrapper, ProductImage } from './styles';
import type { IRecipeProductsProps } from './types';
import { DictionaryService } from 'service/dictionary/dictionaryService';

export const RecipeProducts = ({ block, copy, trackingEvent }: IRecipeProductsProps): ReactNode => {
  const parsedProducts = parseProducts(block);

  const uniqueProducts = filterUniqueProducts(parsedProducts);

  return (
    <>
      {uniqueProducts?.length ? (
        <>
          <StyledTitle tag="h2" type="md">
            {DictionaryService.getCopy('buy_products', copy)}
          </StyledTitle>
          {uniqueProducts.map((product: any, index: number) => {
            const uniqueKey = product.Id ? `${product.Id}-${index}` : `product-${index}`;
            return (
              <ProductWrapper
                key={uniqueKey}
                onClick={() => trackingEvent && trackingEvent(product)}
              >
                <Link href={product.ArticleUnit.Article.ProductLink} target="_blank">
                  <>
                    <ProductImage>
                      <NextImage
                        priority
                        sources={ImagesService.getPictureSources(
                          product.ArticleUnit.Article.ProductImage,
                        )}
                        alt={product.ArticleSummaryText}
                      />
                    </ProductImage>
                    <span>{product.ArticleSummaryText}</span>
                  </>
                </Link>
              </ProductWrapper>
            );
          })}
        </>
      ) : (
        ''
      )}
    </>
  );
};
